import { FaWhatsapp } from 'react-icons/fa';
import { useEffect, useState } from 'react';
import LargeHeroBackground from '../../assets/hero_large.png';
import SmallHeroBackground from '../../assets/hero_small.png';
import {
  button,
  contentContainer,
  descriptionText,
  heading,
  overlay,
  titleText,
} from './Hero.styles';
import { handleOpenLink } from '../../utils/common';

export default function Hero() {
  const [isMobile, setIsMobile] = useState(null);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const checkScreen = () => setIsMobile(window.innerWidth < 768);
    checkScreen();
    window.addEventListener('resize', checkScreen);
    return () => window.removeEventListener('resize', checkScreen);
  }, []);

  const heroBackgroundImage = isMobile
    ? SmallHeroBackground
    : LargeHeroBackground;

  return (
    <section
      id='inicio'
      className={heading}
      style={{
        backgroundImage:
          isMobile === null ? 'none' : `url(${heroBackgroundImage})`,
      }}
    >
      <div className={overlay} />
      <div className={contentContainer}>
        <p className={titleText}>Realce sua beleza com</p>
        <p className={titleText}>harmonia e naturalidade!</p>
        <p className={descriptionText}>
          Descubra a excelência em harmonização facial com tratamentos avançados
          e personalizados.
        </p>
        <button
          onClick={() =>
            handleOpenLink(
              'https://wa.me/+5519996268961?text=Ol%C3%A1,%20venho%20atrav%C3%A9s%20do%20site%20e%20gostaria%20de%20agendar%20uma%20Avalia%C3%A7%C3%A3o%20em%20Harmoniza%C3%A7%C3%A3o%20Orofacial%20com%20a%C2%A0Dra%C2%A0Bruna%C2%A0Fais.',
              'agendar_consulta_click',
              'Agendar consulta',
              window.location.pathname
            )
          }
          className={button}
        >
          <FaWhatsapp />
          Agendar consulta
        </button>
      </div>
    </section>
  );
}
